import request from "../Requests/requests";
import { editSettings } from "../store/settingsReducer";

export const changingSettings = (payload) => {
    return async dispatch => {
        try {
            const response = await request.put(`/Settings/`, { 
                userId: localStorage.getItem('userID'),
                settingsType: payload.settingsType,
                isSmartDateRecognition: payload.isSmartDateRecognition,
                isTimeTracking: payload.isTimeTracking,
                timeZone: payload.timeZone,
                currentTimeZone: payload.currentTimeZone,
                timeZoneId: payload.timeZoneId,
                currentTimeZoneId: payload.currentTimeZoneId,
                isGCalendarIntegrated: payload.isGCalendarIntegrated
                })
            dispatch(editSettings(payload))
            const data = response.data
            return data
        } catch (error) {
            return error
        }
        
       ;
    }
}